export default {
  api: {
    operationFailed: "Operation failed",
  },
};
